import { render, staticRenderFns } from "./pcat2.vue?vue&type=template&id=06c81b47"
import script from "./pcat2.vue?vue&type=script&lang=js"
export * from "./pcat2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports